export default __webpack_public_path__ + "static/media/fi.e5f6b305.svg";